import { Logger } from '@kinopoisk-int/logger';

export type IYandexMetrikaEvents =
    | {
          type: YandexMetrikaMethods.reachGoal;
          payload: Parameters<IYandexMetrikaReachGoalHandler>;
      }
    | {
          type: YandexMetrikaMethods.params;
          payload: Parameters<IYandexMetrikaParamsHandler>;
      }
    | {
          type: YandexMetrikaMethods.hit;
          payload: Parameters<YandexMetrikaHitHandler>;
      };

export type IYandexMetrikaReachGoalHandler = (
    target: string,
    params?: object,
    callback?: Function,
    ctx?: object
) => void;

type IYandexMetrikaParamsDataElement = string | number;

type IYandexMetrikaParamsData = {
    [key in IYandexMetrikaParamsDataElement]:
        | IYandexMetrikaParamsData
        | IYandexMetrikaParamsDataElement
        | IYandexMetrikaParamsDataElement[];
};

export type IYandexMetrikaParamsHandler = (
    params: IYandexMetrikaParamsData | IYandexMetrikaParamsData[]
) => void;

// for more information see the documentation https://yandex.ru/support/metrica/objects/hit.html
interface YandexMetrikaHitOptions {
    title?: string;
    referer?: string;
    callback?(): void;
    ctx?: object;
}

export interface YandexMetrikaHitHandler {
    (url: string, options?: YandexMetrikaHitOptions): void;
}

export type IYandexMetrikaInitParams = {
    id: number;
    clickmap?: boolean;
    trackLinks?: boolean;
    accurateTrackBounce?: boolean;
    webvisor?: boolean;
    experiments?: string;
    params?: IYandexMetrikaParams;
    yaGdprLang?: string;
    useUtmFromSessionStorage?: boolean;
    isMetrikaInitParamsLoggingEnabled?: boolean;
};

export enum YandexMetrikaMethods {
    reachGoal = 'reachGoal',
    params = 'params',
    hit = 'hit',
}

export type IYandexMetrikaCounterParams = {
    id: number;
    clickmap?: boolean;
    trackLinks?: boolean;
    accurateTrackBounce?: boolean;
    webvisor?: boolean;
    experiments?: string;
    params?: IYandexMetrikaParams;
    yaGDPRLang?: string;
    url?: string;
};

type IYandexMetrikaParams = {
    appName: string;
    appVersion: string;
    isAuthorized: boolean;
};

export interface IYandexMetrikaApi {
    emit(event: IYandexMetrikaEvents): void;

    ymclidPromise: Promise<string | undefined>;
}

export interface IYandexMetrika {
    reachGoal: IYandexMetrikaReachGoalHandler;
    params: IYandexMetrikaParamsHandler;
    hit: YandexMetrikaHitHandler;
    // based on https://arcanum.yandex-team.ru/arcadia/metrika/frontend/watch/ai-friendly/src/providers/getYmclid/const.ts?rev=r16997105
    getYmclid?(callback?: (ymclid?: string) => void): void;
    getClientID?(callback?: (clientID?: string) => void): void;
}

export type GlobalCounter = `yaCounter${number}`;

export interface IYandexMetrikaConstructor {
    new (params: IYandexMetrikaCounterParams): IYandexMetrika;
}

export interface IYandexMetrikaService {
    readonly ymclidPromise: Promise<string | undefined>;

    reachGoal: IYandexMetrikaReachGoalHandler;
    params: IYandexMetrikaParamsHandler;
    hit: YandexMetrikaHitHandler;
}

export interface IYandexMetrikaServiceParams {
    metrikaApi: IYandexMetrikaApi;
    getLogger?: () => Logger;
    debug?: boolean;
}
